import React from 'react';
import { FaRegFolder } from "react-icons/fa";
import { RxOpenInNewWindow } from 'react-icons/rx';

const BlogCard = ({title, description, listItem, link, toggleONVisibility, toggleOFFVisibility}) => {
  return (
    <a href={link} target="_blank" rel="noreferrer" onMouseEnter={toggleONVisibility} onMouseLeave={toggleOFFVisibility} >
        <div className='w-full h-80 rounded-lg bg-[#112240] p-7 flex flex-col gap-6 hover:-translate-y-2 transition-transform duration-300 group justify-between'>
        <div className='flex justify-between items-center'>
            <FaRegFolder className='text-4xl text-textGreen'/>
            <RxOpenInNewWindow className='text-4xl hover:text-textGreen'/>
        </div>
        <div>
            <h2 className='text-xl font-titleFont font-semibold tracking-wide group-hover:text-textGreen'>{title}</h2>
            <p className='text-sm mt-3'>{description}</p>
        </div>
        <ul className='text-xs mdl:text-sm text-textDark flex items-center gap-2 justify-between flex-wrap'>
            {
                listItem && listItem.map((item, i)=>{
                    return <li key={item+i}>{item}</li>
                })
            }
        </ul>
        </div>
    </a>
  )
}

export default BlogCard